export default __webpack_public_path__ + "static/media/playing_guitar_icon.97ab70b7.svg";